module.exports = __webpack_public_path__ + "fd1876ca688c032eb15ab25183fad840.pdf";